import { DevPortalTestingAccount } from '../interfaces/user';

export const emptyDevPortalTestingAccount: DevPortalTestingAccount = {
  username: '',
  cluster: '',
  password: '',
  dateCreated: '',
  dateUpdated: '',
  email: '',
  hatActive: false,
  organisationId: -1,
};
